namespace Nobox.CRM {
    export interface ExpensesForm {
        ExspenseDate: CustomDateTimeEditor;
        Currencies: CurrencyEditor;
        ExpenseAmount: AutoNumericEditor;
        ContactIds: Serenity.ServiceLookupEditor;
        GroupIds: Serenity.ServiceLookupEditor;
        DealIds: Serenity.ServiceLookupEditor;
        Category: Serenity.ServiceLookupEditor;
        Description: Serenity.TextAreaEditor;
        Upload: Serenity.ImageUploadEditor;
    }

    export class ExpensesForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Expenses';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExpensesForm.init)  {
                ExpensesForm.init = true;

                var s = Serenity;
                var w0 = CustomDateTimeEditor;
                var w1 = CurrencyEditor;
                var w2 = AutoNumericEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.ImageUploadEditor;

                Q.initFormType(ExpensesForm, [
                    'ExspenseDate', w0,
                    'Currencies', w1,
                    'ExpenseAmount', w2,
                    'ContactIds', w3,
                    'GroupIds', w3,
                    'DealIds', w3,
                    'Category', w3,
                    'Description', w4,
                    'Upload', w5
                ]);
            }
        }
    }
}
